import { Editor } from 'domains/reporter/RichTextEditor/core';
import { withInlineTemplate } from '../common/inlineTemplate';
import type { CreateEnhanceEditorState } from '../../types';
import {
  MacroPlaceholderRenderMode,
  type MacroPlaceholderPluginPropertyOptions,
  type MacroPlaceholderPluginElement,
} from './types';
import { Element } from 'slate';

export const enhanceEditorStateMacroPlaceholder: CreateEnhanceEditorState<
  MacroPlaceholderPluginPropertyOptions
> = (options) => (editor: Editor) => {
  const enhancedEditor = withInlineTemplate<MacroPlaceholderPluginElement>({
    pluginID: options.pluginID,
  })(editor);

  if (options.renderMode !== MacroPlaceholderRenderMode.ChipElement) {
    return enhancedEditor;
  }

  const { isVoid } = enhancedEditor;

  enhancedEditor.isVoid = (element: Element) => {
    return element.type === options.pluginID ? true : isVoid(element);
  };

  return enhancedEditor;
};
